module.exports = __webpack_public_path__ + "img/empty-task.754e9c23.svg";